export const socialsData = {
    github: 'https://github.com/ankush0939',
    facebook: 'https://www.facebook.com/profile.php?id=100092227135927',
    linkedIn: 'https://www.linkedin.com/in/ankush-mishra-b549ba197/',
    instagram: 'https://www.instagram.com/its.__.ankush/',
    // codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/iam_ankush_09',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@ankushmishra0939',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/'
}